import './App.scss';
import React, { useEffect, useState, useContext } from 'react'

import { Routes, Route, useNavigate } from 'react-router-dom';

import NavBar from 'Components/NavBar/NavBar';
import Footer from 'Components/Footer/Footer';
import Home from "Container/Home/Home";
import RecherchePersonne from 'Container/GestionContrat/RecherchePersonne/RecherchePersonne';
import FichePersonne from 'Container/GestionContrat/FichePersonne/FichePersonne';
import FicheContrat from 'Container/GestionContrat/FicheContrat/FicheContrat';
import AnnuaireCorresponsants from 'Container/AnnuaireCorrespondant/AnnuaireCorrespondants';
import PlanSite from 'Container/PlanSite/PlanSite';
import FormulaireContainer from './Container/Formulaires/FormulaireContainer/FormulaireContainer';
import ChangementAdresse from './Container/Formulaires/ChangementAdresse/ChangementAdresse';
import ChangementCoordonnees from './Container/Formulaires/ChangementCoordonnees/ChangementCoordonnees';
import AjouterModifierContribution from "./Container/AjouterModifierContribution/AjouterModifierContribution";
import VoirContribution from "./Container/VoirContribution/VoirContribution";
import MnhPratique from "./Container/MnhPratique/MnhPratique";
import Keycloak from "keycloak-js";
import { jwtDecode } from "jwt-decode";
import DisplayContributions from "./Components/DisplayContributions/DisplayContributions";
import AddUpdateMessagesAccueil from "./Container/AddUpdateMessagesAccueil/AddUpdateMessagesAccueil";
import { fetchInfosCorrespondant, updateKeycloak } from "./Redux/keycloak/keycloakReducer";
import { useDispatch, useSelector } from "react-redux";
import { isAdminKc, isCorrespondantKc } from "./utils/keycloakUtils";
import LoadingOverlay from "./Components/LoadingOverlay/LoadingOverlay";
import Cgu from "./Container/Cgu/Cgu";
import Error from "./Container/Error/Error";
import DeclarationDeces from "./Container/Formulaires/DeclarationDeces/DeclarationDeces";
import AjoutAyantDroits from "./Container/Formulaires/AjoutAyantDroits/AjoutAyantDroits";
import ChangementNumSecuriteSociale
    from "./Container/Formulaires/ChangementNumSecuriteSociale/ChangementNumSecuriteSociale";
import ChangementRib from "./Container/Formulaires/ChangementRib/ChangementRib";
import ChangementNom from "./Container/Formulaires/ChangementNom/ChangementNom";
import DemandeDocument from "./Container/Formulaires/DemandeDocument/DemandeDocument";
import ChangementGarantie from "./Container/Formulaires/ChangementGarantie/ChangementGarantie";
import ChangementSituation from "./Container/Formulaires/ChangementSituation/ChangementSituation";
import RadiationAyantDroit from "./Container/Formulaires/RadiationAyantDroit/RadiationAyantDroit";
import ListeDemande from "./Container/DemandeIndemnisation/ListeDemande/ListeDemande";
import FormulaireIndemnisation from "./Container/DemandeIndemnisation/FormulaireIndemnisation/FormulaireIndemnisation";
import Remboursements from "./Container/DemandeIndemnisation/Remboursements/Remboursements";
import { envoiTrace } from "./api/techniqueEdclService";
import ProfilCorrespondant from "./Container/ProfilCorrespondant/ProfilCorrespondant";
import { emptyObject, isInteger } from "./utils/formUtils";
import { fetchMessagesAccueil, fetchMnhPratique, fetchReferences } from "./Redux/resources/resourcesReducer";
import moment from "moment";
import DeclarationAccessibilite from "./Container/DeclarationAccessibilite/DeclarationAccessibilite";

function App() {

    // TODO chercher contrôle reducer chargé
    const {
        keycloakReduce,
        infosCorrespondant,
        mnhPratique,
        mnhPratiqueLastUpdated,
        referencesApp,
        referencesAppLastUpdated,
        messagesAccueil,
        messagesAccueilLastUpdated,
    } = useSelector(state => ({
        ...state.keycloakReducer,
        ...state.resourcesReducer,
    }))

    const CONF = window?.confPub;
    const ROUTES_PAGES = CONF?.ROUTES?.PAGES;

    const dispatch = useDispatch()
    const navigate = useNavigate()

    // A consolider
    //const mode = useSelector((state) => state.themeReducer);

    const [authenticated, setAuthenticated] = useState(false)
    const [keycloak, setKeycloak] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isAppLoading, setIsAppLoading] = useState(true)
    const [loadingInfosCorrespondant, setLoadingInfosCorrespondant] = useState(true);

    useEffect(() => {

        // TODO X2 redux? (marche pas comme ça avec les circular refs dans kc)
        const kc = new Keycloak('/keycloak.json')

        kc.onAuthRefreshError = () => {
            localStorage.removeItem('alreadyLoggedIn')
        }

        const reload = !localStorage.getItem('alreadyLoggedIn')

        kc.onTokenExpired = () => {

            // localStorage.removeItem('accessToken')

            kc.updateToken(15).then(() => {

                const decodedToken = jwtDecode(kc?.token)
                const isRenderedAsAdmin = isAdminKc(decodedToken)

                dispatch(updateKeycloak({ decodedToken, isRenderedAsAdmin }))

                localStorage.setItem('accessToken', kc?.token ? kc.token : '')
                localStorage.setItem('alreadyLoggedIn', true)

            }).catch((err) => {

                console.log('err logout')
                console.log(err)
            })
        }

        kc.init({ onLoad: 'login-required' }).then(authenticated => {

            setAuthenticated(authenticated)
            setKeycloak(kc)

            const decodedToken = jwtDecode(kc?.token)
            const isRenderedAsAdmin = isAdminKc(decodedToken)

            dispatch(updateKeycloak({ decodedToken, isRenderedAsAdmin }))

            localStorage.setItem('accessToken', authenticated ? kc?.token : '')
            localStorage.setItem('alreadyLoggedIn', true)

            // TODO voir pour tester avec react-oidc-context pour avoir le init géré par le context provider
            if (reload) {

                window?.location?.reload()

            } else {

                if (decodedToken?.neverLoggedIn) {
                    navigate(ROUTES_PAGES?.CORRESPONDANTS?.CGU)
                }

                const idGrm = decodedToken?.idGrm

                if (idGrm) {

                    if (idGrm === 0) {
                        envoiTrace("9999",
                            CONF?.CODES?.CODES_TRACES?.CONNEXION_ADMIN,
                            {
                                email: decodedToken?.email,
                                nomCorrespondant: decodedToken?.family_name,
                                prenomCorrespondant: decodedToken?.given_name,
                            })
                    } else if (isInteger(idGrm)) {

                        envoiTrace(idGrm,
                            CONF?.CODES?.CODES_TRACES?.CONNEXION,
                            {
                                email: decodedToken?.email,
                                nomCorrespondant: decodedToken?.family_name,
                                prenomCorrespondant: decodedToken?.given_name,
                            })
                    }
                }

                setIsAppLoading(false)
            }
        }).catch(err => {

            console.log('kc err')
            console.log(err)
            navigate(ROUTES_PAGES?.ERROR)
            setIsAppLoading(false)
        })
    }, [])

    const token = localStorage.getItem('accessToken')

    useEffect(() => {

        // console.log("keycloakReduce?.decodedToken?.idGrm")
        // console.log(keycloakReduce?.decodedToken?.idGrm)
        // console.log("infosCorrespondant")
        // console.log(infosCorrespondant)


        if (keycloakReduce?.decodedToken?.idGrm
            && infosCorrespondant?.numPersCorr !== keycloakReduce?.decodedToken?.idGrm && token) {
            // && loadingInfosCorrespondant) {

            dispatch(fetchInfosCorrespondant(keycloakReduce?.decodedToken?.idGrm))
        }

        const DD_SLASH_MM_SLASH_YYYY = CONF?.PATTERNS?.DD_SLASH_MM_SLASH_YYYY
        const DD_SLASH_MM_SLASH_YYYY_SPACE_HH_COLON_MM_COLON_SS = CONF?.PATTERNS?.DD_SLASH_MM_SLASH_YYYY_SPACE_HH_COLON_MM_COLON_SS
        const today = moment().format(DD_SLASH_MM_SLASH_YYYY)
        const nowHour = moment().hour()

        if (keycloakReduce?.decodedToken?.idGrm === 0
            || ((mnhPratique?.length === 0 && mnhPratiqueLastUpdated !== today)
                || emptyObject(referencesApp) && referencesAppLastUpdated !== today) && token) {

            if (mnhPratiqueLastUpdated !== today) {
                dispatch(fetchMnhPratique())
            }

            if (referencesAppLastUpdated !== today) {
                dispatch((fetchReferences()))
            }
        }

        const momentMessagesAccueilLastUpdated = moment(messagesAccueilLastUpdated, DD_SLASH_MM_SLASH_YYYY_SPACE_HH_COLON_MM_COLON_SS)

        if (momentMessagesAccueilLastUpdated.hour() !== nowHour
            || messagesAccueil?.length === 0
            || keycloakReduce?.decodedToken?.idGrm === 0 && token) {

            console.log("Maj messagesAccueil")

            dispatch(fetchMessagesAccueil())
        }

    }, [keycloakReduce, token])

    // useEffect(() => {
    //
    //     async function fetchLol() {
    //         try {
    //             const profile = await keycloak?.loadUserProfile();
    //             console.log('Retrieved user profile:', profile);
    //         } catch (error) {
    //             console.error('Failed to load user profile:', error);
    //         }
    //     }
    //     fetchLol()
    //
    // }, [keycloak])

    // if (!mnhPratiquePageRef) {
    //     return (<>...</>)
    // }

    // console.log('keycloakReduce?.decodedToken')
    // console.log(keycloakReduce?.decodedToken)

    return (
        // TODO devrait avoir le container ici, pas partout dans les enfants
        <div className="App">

            { isAppLoading ? <LoadingOverlay classes="opaque-overlay" fadeClasses="fade-in-and-out"/> : '' }

            <div>
                <NavBar
                    keycloak={ keycloak }
                    setIsAppLoading={ setIsAppLoading }
                />

                { isLoading ? <LoadingOverlay classes="upload-overlay"/> : '' }

                <Routes>
                    { keycloakReduce?.decodedToken
                        ? keycloakReduce?.decodedToken?.neverLoggedIn
                            ? (<>
                                { isCorrespondantKc(keycloakReduce?.decodedToken) ? (<>
                                    <Route path={ ROUTES_PAGES?.CORRESPONDANTS?.CGU } element={
                                        <Cgu
                                            keycloak={ keycloak }
                                            setIsAppLoading={ setIsAppLoading }
                                        />
                                    }/>
                                </>) : '' }
                            </>) : (<>
                                <Route path={ ROUTES_PAGES?.ROOT } element={ <Home/> }/>

                                <Route path={ ROUTES_PAGES?.RECHERCHE_PERSONNE } element={ <RecherchePersonne/> }/>
                                <Route path={ ROUTES_PAGES?.FICHE_PERSONNE } element={ <FichePersonne/> }/>
                                <Route path={ ROUTES_PAGES?.FICHE_CONTRAT } element={ <FicheContrat/> }/>
                                <Route path={ ROUTES_PAGES?.ANNUAIRE_CORRESPONDANTS }
                                       element={ <AnnuaireCorresponsants/> }/>
                                <Route path={ ROUTES_PAGES?.INFOS_GENERALES } element={ <DisplayContributions/> }/>

                                <Route path={ ROUTES_PAGES?.PLAN_SITE } element={ <PlanSite/> }/>

                                <Route path={ ROUTES_PAGES?.FORMULAIRES?.CONTAINER?.MAIN }
                                       element={ <FormulaireContainer/> }>
                                    <Route path={ ROUTES_PAGES?.FORMULAIRES?.CONTAINER?.AJOUT_AYANT_DROITS }
                                           element={ <AjoutAyantDroits isInside={ true }/> }/>
                                    <Route path={ ROUTES_PAGES?.FORMULAIRES?.CONTAINER?.CHANGEMENT_ADRESSE }
                                           element={ <ChangementAdresse isInside={ true }/> }/>
                                    <Route path={ ROUTES_PAGES?.FORMULAIRES?.CONTAINER?.CHANGEMENT_COORDONNEES }
                                           element={ <ChangementCoordonnees isInside={ true }/> }/>
                                    <Route path={ ROUTES_PAGES?.FORMULAIRES?.CONTAINER?.CHANGEMENT_NOM }
                                           element={ <ChangementNom isInside={ true }/> }/>
                                    <Route path={ ROUTES_PAGES?.FORMULAIRES?.CONTAINER?.CHANGEMENT_RIB }
                                           element={ <ChangementRib isInside={ true }/> }/>
                                    <Route
                                        path={ ROUTES_PAGES?.FORMULAIRES?.CONTAINER?.CHANGEMENT_NUM_SECURITE_SOCIALE }
                                        element={ <ChangementNumSecuriteSociale isInside={ true }/> }/>
                                    <Route path={ ROUTES_PAGES?.FORMULAIRES?.CONTAINER?.DECLARAION_DECES }
                                           element={ <DeclarationDeces isInside={ true }/> }/>
                                    <Route path={ ROUTES_PAGES?.FORMULAIRES?.CONTAINER?.DEMANDE_DOCUMENT }
                                           element={ <DemandeDocument isInside={ true }/> }/>
                                    <Route path={ ROUTES_PAGES?.FORMULAIRES?.CONTAINER?.CHANGEMENT_GARANTIE }
                                           element={ <ChangementGarantie isInside={ true }/> }/>
                                    <Route path={ ROUTES_PAGES?.FORMULAIRES?.CONTAINER?.CHANGEMENT_SITUATION }
                                           element={ <ChangementSituation isInside={ true }/> }/>
                                    <Route path={ ROUTES_PAGES?.FORMULAIRES?.CONTAINER?.RADIATION_AYANT_DROIT }
                                           element={ <RadiationAyantDroit isInside={ true }/> }/>
                                </Route>

                                <Route path={ ROUTES_PAGES?.FORMULAIRES?.DIRECT?.AJOUT_AYANT_DROITS }
                                       element={ <AjoutAyantDroits/> }/>
                                <Route path={ ROUTES_PAGES?.FORMULAIRES?.DIRECT?.CHANGEMENT_ADRESSE }
                                       element={ <ChangementAdresse/> }/>
                                <Route path={ ROUTES_PAGES?.FORMULAIRES?.DIRECT?.CHANGEMENT_COORDONNEES }
                                       element={ <ChangementCoordonnees/> }/>
                                <Route path={ ROUTES_PAGES?.FORMULAIRES?.DIRECT?.CHANGEMENT_NOM }
                                       element={ <ChangementNom/> }/>
                                <Route path={ ROUTES_PAGES?.FORMULAIRES?.DIRECT?.CHANGEMENT_RIB }
                                       element={ <ChangementRib/> }/>
                                <Route path={ ROUTES_PAGES?.FORMULAIRES?.DIRECT?.CHANGEMENT_NUM_SECURITE_SOCIALE }
                                       element={ <ChangementNumSecuriteSociale/> }/>
                                <Route path={ ROUTES_PAGES?.FORMULAIRES?.DIRECT?.DECLARAION_DECES }
                                       element={ <DeclarationDeces/> }/>
                                <Route path={ ROUTES_PAGES?.FORMULAIRES?.DIRECT?.DEMANDE_DOCUMENT }
                                       element={ <DemandeDocument/> }/>
                                <Route path={ ROUTES_PAGES?.FORMULAIRES?.DIRECT?.CHANGEMENT_GARANTIE }
                                       element={ <ChangementGarantie/> }/>
                                <Route path={ ROUTES_PAGES?.FORMULAIRES?.DIRECT?.CHANGEMENT_SITUATION }
                                       element={ <ChangementSituation/> }/>
                                <Route path={ ROUTES_PAGES?.FORMULAIRES?.DIRECT?.RADIATION_AYANT_DROIT }
                                       element={ <RadiationAyantDroit/> }/>

                                <Route path={ ROUTES_PAGES?.DEMANDE_INDEMNISATION?.REMBOURSEMENTS }
                                       element={ <Remboursements/> }/>
                                <Route path={ ROUTES_PAGES?.DEMANDE_INDEMNISATION?.LISTE_INDEMNISATION }
                                       element={ <ListeDemande/> }/>
                                <Route path={ ROUTES_PAGES?.DEMANDE_INDEMNISATION?.FORMULAIRE_INDEMNISATION }
                                       element={ <FormulaireIndemnisation/> }/>

                                { mnhPratique?.length > 0 && mnhPratique.map((page, key) => {
                                    return (
                                        <Route key={ key } path={ `/mnh-pratique${ page?.pageUrl }` }
                                               element={ <MnhPratique/> }/>
                                    )
                                }) }

                                <Route path={ ROUTES_PAGES?.CONTRIBUTIONS?.VOIR_CONTRIBUTION }
                                       element={ <VoirContribution/> }/>

                                <Route path={ ROUTES_PAGES?.PROFIL?.MAIN } element={ <ProfilCorrespondant/> }/>

                                <Route path={ ROUTES_PAGES?.ACCESSIBILITE } element={ <DeclarationAccessibilite/> }/>

                                {/*Routes admin*/ }

                                { isAdminKc(keycloakReduce?.decodedToken) ? (<>
                                    <Route path={ ROUTES_PAGES?.ADMIN?.AJOUTER_CONTRIBUTION }
                                           element={ <AjouterModifierContribution/> }/>
                                    <Route path={ ROUTES_PAGES?.ADMIN?.MODIFIER_CONTRIBUTION }
                                           element={ <AjouterModifierContribution/> }/>

                                    <Route path={ ROUTES_PAGES?.ADMIN?.AJOUTER_MODIFIER_MSG_ACCUEIL }
                                           element={ <AddUpdateMessagesAccueil/> }/>
                                </>) : '' }

                            </>) : (<>
                        </>) }

                    {/*<Route path={ '/error' } element={ <Error keycloak={ keycloak }/> }/>*/ }
                    <Route path={ '/*' } element={ <Error keycloak={ keycloak }/> }/>

                </Routes>

                { keycloakReduce?.decodedToken && !keycloakReduce?.decodedToken?.neverLoggedIn ? (
                    <Footer/>
                ) : '' }

            </div>
        </div>
    );
}

export default App;
